import {useDispatch, useSelector} from "react-redux";
import {useEffect, useMemo, useState} from "react";
import {chunk} from "lodash";
import axios from "axios";

export const useImage = (imageUrl) => {
  const [image, setImage] = useState(null)
  useEffect(() => {
    setImage(null)
    const img = new Image();
    img.onload = function () {
      setImage(img)
    }
    img.src = imageUrl
  }, [imageUrl]);

  return image
}

export const preloadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(url);
    img.onerror = () => reject(new Error(`Error loading image ${url}`));
    img.src = url;
  });
}

export const preloadImages = (urls, batchSize = 5, progress) => {
  return new Promise(async (resolve, reject) => {
    if (progress) progress(0);
    const batches = chunk(urls, batchSize);
    const totalBatches = batches.length
    while (batches.length) {
      const batch = batches.shift();
      await Promise.all(batch.map(url => preloadImage(url)));
      if (progress) progress((1 - batches.length / totalBatches) * 100);
    }

    resolve()
  })
}

export const useMosaicImages = (pictureMode = 'stored_photos') => {
  const dispatch = useDispatch()

  const images = useSelector(state => {
    switch (pictureMode) {
      case 'media_files':
        return state.mediaFiles
      case 'tag_owner_images':
        return state.tagOwnerImages
      case 'stored_photos':
      default:
        return state.storedPhotos
    }
  })

  useEffect(() => {
    if (images && images.length > 0) return

    axios
      .get(`/public/picture_mosaics/initial_images?mode=${pictureMode}`)
      .then((response) => {
        switch (pictureMode) {
          case 'media_files':
            dispatch({type: "CABLE_MEDIA_FILES_CREATED", payload: response.data.media_files})
            break;
          case 'tag_owner_images':
            dispatch({type: "CABLE_TAG_OWNER_IMAGES_CREATED", payload: response.data.tag_owner_images})
            break;
          case 'stored_photos':
          default:
            dispatch({type: "CABLE_STORED_PHOTOS_CREATED", payload: response.data.stored_photos})
            break;
        }
      }).catch(error => {
      alert(error)
      console.error(error)
    })
  }, [images?.length, pictureMode]);

  return useMemo(() => {
    switch (pictureMode) {
      case 'media_files':
        return images
          ?.filter(mediaFile => mediaFile.file?.urls)
          ?.map(mediaFile => {
            return {
              ...mediaFile,
              url: mediaFile.file?.url,
              urls: mediaFile.file?.urls,
            }
          })
      case 'tag_owner_images':
        return images
          ?.filter(tagOwnerImage => tagOwnerImage.image?.urls)
          ?.map(tagOwnerImage => {
            return {
              ...tagOwnerImage,
              url: tagOwnerImage.image?.url,
              urls: tagOwnerImage.image?.urls,
            }
          })
      case 'stored_photos':
      default:
        return images
          ?.filter(storedPhoto => storedPhoto.photo?.urls)
          ?.map(storedPhoto => {
            return {
              ...storedPhoto,
              url: storedPhoto.photo?.url,
              urls: storedPhoto.photo?.urls,
            }
          })
    }
  }, [images, pictureMode])
}
